// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mirrors \`.form-input\` + \`.form-input.mono\` so the phone field is visually
   identical to the other mono inputs (RUT, email). The border lives on the
   container; the inner field is borderless so "+56" sits inside the same box. */
.phone-input {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  padding: 7px 10px;
  border-radius: var(--radius-1);
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  color: var(--text);
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}

.phone-input:focus-within {
  border-color: var(--signal);
  box-shadow: var(--focus-ring);
}

.phone-input.error {
  border-color: var(--danger);
  box-shadow: var(--focus-ring-err);
}

.phone-input__cc {
  color: var(--text-muted);
  user-select: none;
  flex-shrink: 0;
}

.phone-input__field {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  color: var(--text);
}

.phone-input__field::placeholder {
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/shared/OrgModales/PhoneInput.css"],"names":[],"mappings":"AAAA;;gFAEgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB;;yBAEuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Mirrors `.form-input` + `.form-input.mono` so the phone field is visually\n   identical to the other mono inputs (RUT, email). The border lives on the\n   container; the inner field is borderless so \"+56\" sits inside the same box. */\n.phone-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  padding: 7px 10px;\n  border-radius: var(--radius-1);\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  color: var(--text);\n  transition:\n    border-color 120ms ease,\n    box-shadow 120ms ease;\n}\n\n.phone-input:focus-within {\n  border-color: var(--signal);\n  box-shadow: var(--focus-ring);\n}\n\n.phone-input.error {\n  border-color: var(--danger);\n  box-shadow: var(--focus-ring-err);\n}\n\n.phone-input__cc {\n  color: var(--text-muted);\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.phone-input__field {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  padding: 0;\n  font-family: inherit;\n  font-size: inherit;\n  color: var(--text);\n}\n\n.phone-input__field::placeholder {\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
